import { useState, useContext, useEffect } from "react"
import Context from "../../../context/Context";
import { Box, Stack, TextField, Typography, Button, CircularProgress, IconButton } from "@mui/material"
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { login } from "../../../api/app/authRequests";
import { isValidLicenseCode } from "../../../utils/validators/authValidators";

const DEBOUNCE_DELAY = 1000;

const ActivationForm = () => {

    const { showSnackbar, handleLogin } = useContext(Context);

    const [licenseCode, setLicenseCode] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (!isValidLicenseCode(licenseCode)) throw new Error("Invalid license");
            setLoading(true);

            login(licenseCode)
                .then((res) => {
                    showSnackbar("License activated successfully!", "success");
                    handleLogin(res.token)
                })
                .catch((err) => setError(err.message))
                .finally(() => setLoading(false))
        } catch (err) {
            setError(err.message)
        }
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            // clear error if input is empty
            if (!licenseCode.trim()) {
                setError("");
                return;
            }

            if (!isValidLicenseCode(licenseCode)) {
                setError("Invalid license");
            } else {
                // clear error if valid
                setError("");
            }
        }, DEBOUNCE_DELAY);

        return () => clearTimeout(timeout);
    }, [licenseCode]);

    return (
        <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Stack p={{ xs: 4, lg: 6 }} gap={8} >
                <form onSubmit={handleSubmit}>
                    <Stack gap={3}>
                        <Typography variant="h4" fontWeight="bold">Got an invitation code?</Typography>
                        <Typography color="text.secondary">
                            Unlock the power of Inverso and start exploring insights instantly.
                        </Typography>
                        <TextField
                            label="Invitation Code"
                            variant="outlined"
                            placeholder="550e8400-e29b-41d4-a716-446655440000"
                            value={licenseCode}
                            onChange={(e) => setLicenseCode(e.target.value)}
                            error={!!error}
                            helperText={error || " "}
                            fullWidth
                            required
                            autoFocus
                        />

                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={loading}
                            fullWidth
                        >
                            {loading ? <CircularProgress size={24} /> : "Activate"}
                        </Button>
                    </Stack>
                </form>
                <Stack>
                    <Typography variant="body2" align="center" color="text.secondary">Want to try Inverso? Get in touch and obtain an early access invitation code.</Typography>
                    <Stack direction="row" justifyContent="center" spacing={2}>
                        <IconButton
                            color="text.secondary"
                            sx={{
                                "&:hover": {
                                    color: "primary.main"
                                }
                            }}
                            aria-label="send email"
                            href="mailto:andresmonterog@hotmail.com"
                        >
                            <EmailIcon />
                        </IconButton>
                        <IconButton
                            color="text.secondary"
                            sx={{
                                "&:hover": {
                                    color: "primary.main"
                                }
                            }}
                            aria-label="visit LinkedIn"
                            href="https://www.linkedin.com/in/andres-montero-gamboa/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <LinkedInIcon />
                        </IconButton>
                    </Stack>
                </Stack>
            </Stack >
        </Box >



    )
}

export default ActivationForm;